'use strict';

const SiteValues={
  ww:()=>{ var v=(window.innerWidth)?window.innerWidth:window.outerWidth; return v; },
  wh:()=>{ var v=(window.innerHeight)?window.innerHeight:window.outerHeight; return v; },
  dh:()=>{
    var v=Math.max.apply(null,[document.body.clientHeight,document.body.scrollHeight,document.documentElement.scrollHeight,document.documentElement.clientHeight]);
    return v;
  },
  st:()=>{ var v=window.scrollY; return v; },
  hh:()=>{ var v=document.querySelector('.l-header').offsetHeight; return v; },
  ua:navigator.userAgent
};

const isMobile=()=>{ var v=(SiteValues.ww()<=750)?true:false; return v; };
const isDesktop=()=>{ var v=(SiteValues.ww()>=751)?true:false; return v; };
const isTouch=()=>{ var v=(SiteValues.ua.indexOf('iPhone')>1||SiteValues.ua.indexOf('iPad')>1||SiteValues.ua.indexOf('Android')>1)?true:false; return v; };

if(isTouch()){
  document.body.classList.add('u-device-touch');
}else{
  document.body.classList.add('u-device-click');
};

class lazyShow {
  constructor(prefix){
    this.prefix=prefix;
    this.$lazies=document.querySelectorAll(`.${prefix}`);

    this._scroll();

    window.addEventListener('scroll',()=>{
      this._scroll();
    });
  };
  _scroll=()=>{
    let wh=window.innerHeight;
    let minus=wh/1.2;
    this.$lazies.forEach($lazy=>{
      if(!$lazy.classList.contains('is-show')){
        let top=$lazy.getBoundingClientRect().top;
        if(top-minus<=0){
          $lazy.classList.add('is-show');
        };
      };
    });
  };
};

const $lazies=document.querySelectorAll('.u-lazy');
if($lazies.length) new lazyShow('u-lazy');

class introduceMovie {
  constructor(){
    this.$t=document.querySelector('.rjs2-introduce-movie');
    this.$media=document.getElementById('rjs2-introduce-media');
    this._videoOpenClose();
  };
  _videoOpenClose=()=>{
    // .rjs2-introduce-movie要素内の[aria-expanded]要素のみを対象にする
    // これにより、ハンバーガーメニューなどの他の要素を除外
    let $triggers=this.$t ? this.$t.querySelectorAll('[aria-expanded]') : [];
    let isExpanded=false;
    let isHidden=true;
    $triggers.forEach($trigger=>{
      let controls=$trigger.getAttribute('aria-controls');
      let $target=document.getElementById(`${controls}`);
      $trigger.addEventListener('click',event=>{
        event.preventDefault();
        if(isExpanded){
          isExpanded=false;
          isHidden=true;
        }else{
          isExpanded=true;
          isHidden=false;
        };
        $triggers.forEach($trigger=>{
          $trigger.setAttribute('aria-expanded',isExpanded);
        });
        $target.setAttribute('aria-hidden',isHidden);
        if(isHidden){
          this.$media.pause();
        }else{
          this.$media.play();
        };
      });
    });
  };
};

const $introduceMovie=document.querySelector('.rjs2-introduce-movie');
if($introduceMovie){
  new introduceMovie();
};

class fixedBtn {
  constructor(){
    this.$t=document.querySelector('.rjs2-fixed');
    this.$body=document.querySelector('body');
    this.$header=document.querySelector('.header');
    this.$visual=document.querySelector('.rjs2-visual');
    window.addEventListener('load',()=>{
      this._scroll();
    });
    window.addEventListener('scroll',()=>{
      this._scroll();
    });
  };
  _scroll=()=>{
    let st=window.scrollY;
    let wh=window.innerHeight;
    let h={
      header:(this.$header)?this.$header.offsetHeight:0,
      visual:(this.$visual)?this.$visual.offsetHeight:0
    };
    if(st+wh/2>h.header+h.visual){
      this.$body.classList.add('is-over-visual');
    }else{
      this.$body.classList.remove('is-over-visual');
    };
  };
};

const $fixedBtn=document.querySelector('.rjs2-fixed');
if($fixedBtn){
  new fixedBtn();
};